<template>
    <div class="details">
      <div class="details_part2 vHtmlMess" v-html="form.entryGuide"></div>
    </div>
</template>
<script>
import { getActivityDetailInfo } from '../../../utils/interface';
export default {
  data(){
    return {
      form:{},
    }
  },
  methods: {
    init(uuid) {
      this.form = {};
      getActivityDetailInfo({uuid:uuid}).then((res)=>{
        this.form = res;
      });
    }
  },
}
</script>
<style scoped lang="less">
.details {
  width: 1200px;
  box-sizing: border-box;
  background: rgba(255, 255, 255);
  box-shadow: 0px 0px 10px rgba(137, 190, 253, 0.49);
  border-radius: 20px;
  margin: 25px auto 51px;
  padding: 44px 70px 20px;
  .details_part {
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: bold;
    text-align: center;
    color: #1C7EF3;
    .part_tit {
      font-size: 20px;
      font-family: RTWS ShangGothic G0v1;
      color: #1C7EF3;
      margin: 4px 0;
    }
    .part_eng {
      font-size: 12px;
      font-family: PingFang SC;
      color: #1C7EF3;
      opacity: 0.32;
    }
  }
  .details_part1 {
    /deep/img {
      max-width: 100%;
    }
  }
  .details_part2 {
    // margin: 93px 0 83px;
    margin-bottom: 30px;
    .part2_mess {
      font-size: 14px;
      p {
        display: flex;
        align-items: center;
        color: #646464;
        margin-bottom: 8px;
        span {
          font-weight: bold;
          color: #2d50a1;
          margin-left: 8px;
        }
        img {
          width: 200px;
          height: 56px;
          margin-right: 20px;
          margin-left: 8px;
        }
      }
      .con_part2 {
        margin-top: 27px;
      }
    }
  }
  .details_part3 {
    margin-bottom: 100px;
    .part3_mess {
      margin-top: 62px;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .part3_mess_pre {
      position: relative;
      font-size: 18px;
      font-weight: bold;
      color: #000000;
      width: 249px;
      height: 307px;
      background: rgba(248, 248, 248);
      border-radius: 10px;
      .pre_part3_tit {
        width: 137px;
        height: 42px;
        line-height: 42px;
        text-align: center;
        background: rgba(21, 126, 251);
        border-radius: 26px;
        color: #fff;
        position: absolute;
        left: 50%;
        top: -6%;
        transform: translate(-50%, 0);
      }
      .pre_part3_me {
        text-align: center;
        padding-top: 24%;
      }
      img {
        width: 120px;
        height: 154px;
        position: absolute;
        bottom: 8px;
        right: -17px;
      }
    }
    .part3_mess_pre2 {
      position: relative;
      font-size: 22px;
      font-weight: bold;
      color: #000000;
      width: 306px;
      height: 378px;
      background: rgba(248, 248, 248);
      border-radius: 10px;
      .pre_part3_tit {
        width: 168px;
        height: 50px;
        line-height: 50px;
        text-align: center;
        background: rgba(21, 126, 251);
        border-radius: 26px;
        color: #fff;
        position: absolute;
        left: 50%;
        top: -6%;
        transform: translate(-50%, 0);
      }
      .pre_part3_me {
        text-align: center;
        padding-top: 24%;
        font-size: 21px;
      }
      img {
        width: 396px;
        height: 133px;
        position: absolute;
        bottom: 8px;
        right: -78px;
      }
    }
  }
  .details_part4 {
    margin-bottom: 219px;
    .part4_time {
      position: relative;
      margin-top: 176px;
      .part4_time_img {
        width: 100%;
      }
      .part4_time_date {
        position: absolute;
        top: -110px;
        left: 0;
        .part4_time_date1 {
          width: 120px;
          height: 40px;
          background: rgba(21, 126, 251);
          border-radius: 20px;
          font-size: 16px;    
          color: #fff;   
          line-height: 40px;
          text-align: center;
        }
        .part4_time_date2 {
          font-size: 16px;
          margin: 3px 0;
        }
        .part4_time_date3 {
          font-size: 24px;
          font-weight: bold;
        }
      }
      .part4_time_date_mess2 {
        top: 31px;
        left: 27%;
        .part4_time_date3 {
          display: flex;
          align-items: center;
          i {
            color: rgba(216, 216, 216);
            font-size: 17px;
            margin: 0 5px;
          }
        }
      }
      .part4_time_date_mess3 {
        left: 56%;
        .part4_time_date3 {
          display: flex;
          align-items: center;
          i {
            color: rgba(216, 216, 216);
            font-size: 17px;
            margin: 0 5px;
          }
        }
      }
      .part4_time_date_mess4 {
        top: 31px;
        left: 87%;
      }

    }
  }
  .details_part5 {
    margin-bottom: 100px;
    .part5_mess {
      margin-top: 19px;
      font-size: 14px;
      color: #646464;
      line-height: 28px;
    }
  }
  .details_part6 {
    margin-bottom: 100px;
    .part6_mess {
      margin-top: 25px;
      .part6_mess_box {
        font-size: 14px;
        line-height: 28px;
        color: #646464;
        &:nth-of-type(1){
          margin-bottom: 30px;
        }
      }
    }
  }
  .details_part7 {
    .part7_mess {
      .part7_mes_box {
        margin: 32px 0 20px;
        font-size: 14px;
        line-height: 28px;
        color: #646464;
      }
      .part7_button {
        display: flex;
        align-items: center;
        cursor: pointer;
        .part7_button_icon {
          width: 40px;
          height: 40px;
          background: rgba(245, 245, 245, 0.39);
          border-radius: 12px;
          color: #1C7EF3;
          text-align: center;
          line-height: 40px;
          i {
            font-size: 30px;
            color: #1C7EF3;
          }
        }
        
        p {
          font-size: 14px;
          color: #1C7EF3;
          margin-left: 9px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/design/activeList/activeNanDetail.vue